// extracted by mini-css-extract-plugin
module.exports = {"componentsPaymentMethodsContainer":"styles_componentsPaymentMethodsContainer__37C_z"};